/**
 * Payouts: ledger **append-only** de movimientos de dinero (§6.2.3).
 *
 * "Desmarcar un pago" del HTML (defecto F8) ya no existe: se emite un asiento `void`
 * compensatorio con motivo y actor. Nada se borra.
 */
import { z } from 'zod';
import { CentsWireSchema } from '../money.js';

export const PayoutTypeSchema = z.enum(['pay', 'refund', 'void']);
export type PayoutType = z.infer<typeof PayoutTypeSchema>;

export const PayoutSchema = z.object({
  id: z.string().length(26),
  orgId: z.string().min(1),
  betId: z.string().length(26),
  fightId: z.string().length(26),
  type: PayoutTypeSchema,
  amountCents: CentsWireSchema,
  actorUserId: z.string().nullable(),
  terminalId: z.string().nullable(),
  reason: z.string().max(240).nullable(),
  createdAt: z.string().datetime({ offset: true }),
});
export type Payout = z.infer<typeof PayoutSchema>;

/** Movimiento neto por boleto: pagos + reembolsos − anulaciones. */
export function netPayoutCents(payouts: readonly Payout[]): bigint {
  let net = 0n;
  for (const p of payouts) {
    const amount = BigInt(p.amountCents);
    net += p.type === 'void' ? -amount : amount;
  }
  return net;
}
